import { folderSchemas } from "@redotech/redo-model/views/folders";
import { viewWithIdSchemas } from "@redotech/redo-model/views/views";
import * as z from "zod";
import { null as zNull } from "zod";

export const saveOrderTrackingOrderViewsAndFolders = {
  name: "saveOrderTrackingOrderViewsAndFolders" as const,
  input: z.object({
    folders: z.array(folderSchemas["order-tracking-orders"]),
    views: z.array(viewWithIdSchemas["order-tracking-orders"]),
  }),
  output: zNull(),
};
